// extracted by mini-css-extract-plugin
var _1 = "AddressForm_buttonsContainer__Yued5";
var _2 = "AddressForm_editForm__8R7Xs";
var _3 = "AddressForm_editInnerContainer__6wv0f";
var _4 = "AddressForm_header__zyw1s";
var _5 = "AddressForm_inputContainer__oA5ji";
var _6 = "992px";
var _7 = "768px";
var _8 = "AddressForm_phoneNumber__nIhQL";
var _9 = "AddressForm_readOnlyFields__jyECz";
var _a = "AddressForm_readOnlySection__I58lY";
var _b = "\"../shared.module.css\"";
export { _1 as "buttonsContainer", _2 as "editForm", _3 as "editInnerContainer", _4 as "header", _5 as "inputContainer", _6 as "lg", _7 as "md", _8 as "phoneNumber", _9 as "readOnlyFields", _a as "readOnlySection", _b as "shared" }
